/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phone/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import PhoneIcon from 'DesignSystem/Svgs/PhoneIcon/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Phone({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/ResponsibleRelatives/Content/ResponsibleRelative/Contact/Content/Phones/Phone"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let phonePhoneNumberValueData = fromData.useDataFormat({ viewPath,
context: 'phone',
path: 'phone.number',
format: fromFormat.phoneNumberUS,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Phone.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-5yCzy': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-2-5yCzy': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-3-5yCzy': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<PhoneIcon
  viewPath={`${viewPath}/PhoneIcon`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral900}
 data="phone.phone.number"
 format="/Data/format.js phoneNumberUS"
 text={phonePhoneNumberValueData}
/>
</div>
{children}
</React.Fragment>)
}